<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_416_46189)">
			<path
				d="M6.6 12H3.9C3.40294 12 3 12.4029 3 12.9V20.1C3 20.5971 3.40294 21 3.9 21H6.6C7.09706 21 7.5 20.5971 7.5 20.1V12.9C7.5 12.4029 7.09706 12 6.6 12Z"
				:fill="props.iconColor"
			/>
			<path
				d="M13.35 14.7H10.65C10.1529 14.7 9.75 15.1029 9.75 15.6V20.1C9.75 20.597 10.1529 21 10.65 21H13.35C13.8471 21 14.25 20.597 14.25 20.1V15.6C14.25 15.1029 13.8471 14.7 13.35 14.7Z"
				:fill="props.iconColor"
			/>
			<path
				d="M20.1 10.2H17.4C16.9029 10.2 16.5 10.6029 16.5 11.1V20.1C16.5 20.597 16.9029 21 17.4 21H20.1C20.5971 21 21 20.597 21 20.1V11.1C21 10.6029 20.5971 10.2 20.1 10.2Z"
				:fill="props.iconColor"
			/>
			<path
				d="M12 12.8977C12 12.899 12.001 12.9 12.0022 12.9C12.1229 12.8994 12.239 12.8499 12.3285 12.7605L20.1 4.575V6.2C20.1 6.42091 20.279 6.6 20.5 6.6H20.6C20.8209 6.6 21 6.42091 21 6.2V3.45C21 3.2025 20.7975 3 20.55 3H17.8C17.579 3 17.4 3.17909 17.4 3.4V3.5C17.4 3.72091 17.579 3.9 17.8 3.9H19.5015L11.919 11.8785L4.02335 7.2084C3.83336 7.09603 3.58825 7.1588 3.47566 7.34866L3.42479 7.43445C3.31199 7.62466 3.37494 7.8703 3.56531 7.98283L11.7705 12.8325C11.8418 12.8726 11.9175 12.8951 11.9977 12.8955C11.9989 12.8955 12 12.8965 12 12.8977Z"
				:fill="props.iconColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_416_46189">
				<rect width="18" height="18" :fill="props.iconColor" transform="translate(3 3)" />
			</clipPath>
		</defs>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
